module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "booking__room"
  }, [(!_vm.mobile) ? [_c('modal', {
    attrs: {
      "name": _vm.modalName,
      "width": 800,
      "height": 450
    }
  }, [_c('div', {
    staticClass: "carousel"
  }, [_c('div', {
    staticClass: "carousel__primary"
  }, [_c('div', {
    staticClass: "carousel__media"
  }, [_c('div', {
    staticClass: "carousel__image",
    style: ({
      backgroundImage: ("url(" + _vm.image + ")")
    }),
    on: {
      "click": _vm.show
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "carousel__arrows-container"
  }, [(!_vm.hidePrev) ? [_c('svg', {
    staticClass: "carousel__arrows carousel__arrows--prev",
    attrs: {
      "width": "40",
      "height": "40",
      "viewBox": "0 0 40 40",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    },
    on: {
      "click": function($event) {
        _vm.directional('prev')
      }
    }
  }, [_c('circle', {
    attrs: {
      "cx": "20",
      "cy": "20",
      "r": "19.5",
      "fill": "white",
      "stroke": "#DADDDF"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M17 14L23 20L17 26",
      "stroke": "#C45F24",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])] : _vm._e(), _vm._v(" "), (!_vm.hideNext) ? [_c('svg', {
    staticClass: "carousel__arrows carousel__arrows--next",
    attrs: {
      "width": "40",
      "height": "40",
      "viewBox": "0 0 40 40",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    },
    on: {
      "click": function($event) {
        _vm.directional('next')
      }
    }
  }, [_c('circle', {
    attrs: {
      "cx": "20",
      "cy": "20",
      "r": "19.5",
      "fill": "white",
      "stroke": "#DADDDF"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M17 14L23 20L17 26",
      "stroke": "#C45F24",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])] : _vm._e()], 2)])])])] : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "booking__title",
    domProps: {
      "innerHTML": _vm._s(_vm.roomName)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "booking__image-container",
    on: {
      "click": _vm.show
    }
  }, [_c('div', {
    staticClass: "booking__image",
    style: ({
      backgroundImage: ("url(" + _vm.poster + ")")
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "booking__see-more"
  }, [_vm._v("See more photos!")])]), _vm._v(" "), _c('div', {
    staticClass: "booking__carousel-mobile"
  }, [_c('div', {
    staticClass: "carousel"
  }, [_c('div', {
    staticClass: "carousel__primary"
  }, [_c('div', {
    staticClass: "carousel__media"
  }, [_c('div', {
    staticClass: "carousel__image",
    style: ({
      backgroundImage: ("url(" + _vm.image + ")")
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "carousel__arrows-container"
  }, [(!_vm.hidePrev) ? [_c('svg', {
    staticClass: "carousel__arrows carousel__arrows--prev",
    attrs: {
      "width": "40",
      "height": "40",
      "viewBox": "0 0 40 40",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    },
    on: {
      "click": function($event) {
        _vm.directional('prev')
      }
    }
  }, [_c('circle', {
    attrs: {
      "cx": "20",
      "cy": "20",
      "r": "19.5",
      "fill": "white",
      "stroke": "#DADDDF"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M17 14L23 20L17 26",
      "stroke": "#C45F24",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])] : _vm._e(), _vm._v(" "), (!_vm.hideNext) ? [_c('svg', {
    staticClass: "carousel__arrows carousel__arrows--next",
    attrs: {
      "width": "40",
      "height": "40",
      "viewBox": "0 0 40 40",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    },
    on: {
      "click": function($event) {
        _vm.directional('next')
      }
    }
  }, [_c('circle', {
    attrs: {
      "cx": "20",
      "cy": "20",
      "r": "19.5",
      "fill": "white",
      "stroke": "#DADDDF"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M17 14L23 20L17 26",
      "stroke": "#C45F24",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])] : _vm._e()], 2)])])]), _vm._v(" "), _c('p', {
    staticClass: "booking__info",
    domProps: {
      "innerHTML": _vm._s(_vm.roomDesc)
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a866064","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./source/js/components/Room.vue
// module id = 38
// module chunks = 1